"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Uploader = void 0;
var _react = require("react");
var _UploadButton = require("./Partials/UploadButton");
var _UploadDropZone = require("./Partials/UploadDropZone");
var _Uploader = require("./Uploader.styles");
var _Uploader2 = require("./Uploader.labels");
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Uploader = function Uploader(props) {
  var getLabel = (0, _hooks.useLabels)({
    labels: _Uploader2.labels
  });
  var fileInputRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDragOver = _useState2[0],
    setIsDargOver = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'button' : _props$layout,
    acceptedMimeTypes = props.acceptedMimeTypes,
    _props$maxFileSizeMB = props.maxFileSizeMB,
    maxFileSizeMB = _props$maxFileSizeMB === void 0 ? 3 : _props$maxFileSizeMB,
    isDisabled = props.isDisabled,
    onFileSelected = props.onFileSelected,
    onFileSizeError = props.onFileSizeError,
    onFileTypeError = props.onFileTypeError;
  var inputAcceptanceTypes = (0, _react.useMemo)(function () {
    return (acceptedMimeTypes === null || acceptedMimeTypes === void 0 ? void 0 : acceptedMimeTypes.length) > 0 ? acceptedMimeTypes.map(function (mimeType) {
      return '.' + mimeType.toLowerCase().split('/')[1];
    }).join(', ') : '';
  }, [acceptedMimeTypes]);
  var styles = (0, _Uploader.useStyles)(layout, isDragOver);
  var processFile = function processFile(file) {
    var types = acceptedMimeTypes;
    var maxSize = 1024 * 1024 * maxFileSizeMB;
    if (!types.includes(file.type) && typeof onFileTypeError === 'function') {
      onFileTypeError(file.type);
      setErrorMessage(getLabel('uploader_type_error'));
    } else if (file.size < 100 || file.size > maxSize && typeof onFileSizeError === 'function') {
      setErrorMessage(getLabel('uploader_size_error'));
      onFileSizeError(file.size);
    } else {
      setErrorMessage('');
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        onFileSelected({
          file: file,
          fileData: reader.result
        });
      };
    }
  };
  var handleFileChange = function handleFileChange() {
    try {
      var _fileInputRef$current;
      if (fileInputRef !== null && fileInputRef !== void 0 && (_fileInputRef$current = fileInputRef.current) !== null && _fileInputRef$current !== void 0 && _fileInputRef$current.files && fileInputRef.current.files.length > 0) {
        processFile(fileInputRef.current.files[0]);
      }
    } catch (ex) {
      console.error(ex);
    }
  };
  var handleDragOver = function handleDragOver() {
    if (isDisabled) return;
    setIsDargOver(true);
    if (layout === 'dropzone') {
      var _ref = props,
        onDragOver = _ref.onDragOver;
      if (onDragOver) {
        onDragOver();
      }
    }
  };
  var handleDragLeave = function handleDragLeave() {
    if (isDisabled) return;
    setIsDargOver(false);
    if (layout === 'dropzone') {
      var _ref2 = props,
        onDragLeave = _ref2.onDragLeave;
      if (onDragLeave) {
        onDragLeave();
      }
    }
  };
  var handleFileDrop = function handleFileDrop(event) {
    // Prevent default behavior (Prevent file from being opened)
    event.preventDefault();
    if (event.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      _toConsumableArray(event.dataTransfer.items).forEach(function (item, i) {
        // If dropped items aren't files, reject them
        if (item.kind === 'file') {
          var file = item.getAsFile();
          if (file) {
            processFile(file);
          }
        }
      });
    }
  };
  var handleButtonClick = function handleButtonClick(event) {
    var _fileInputRef$current2;
    fileInputRef === null || fileInputRef === void 0 ? void 0 : (_fileInputRef$current2 = fileInputRef.current) === null || _fileInputRef$current2 === void 0 ? void 0 : _fileInputRef$current2.click();
    if (layout === 'button') {
      var _ref3 = props,
        onClick = _ref3.onClick;
      if (onClick) {
        onClick(event);
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: layout === 'button' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadButton.UploaderButton, _objectSpread(_objectSpread({}, props), {}, {
      ref: fileInputRef,
      isDisabled: isDisabled,
      inputAcceptanceTypes: inputAcceptanceTypes,
      styles: styles,
      onFileChange: handleFileChange,
      onClick: handleButtonClick,
      errorMessage: errorMessage
    })) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadDropZone.UploadDropZone, _objectSpread(_objectSpread({}, props), {}, {
      ref: fileInputRef,
      messagesGender: props.messagesGender,
      inputAcceptanceTypes: inputAcceptanceTypes,
      styles: styles,
      onDrop: handleFileDrop,
      onFileChange: handleFileChange,
      onDragOver: handleDragOver,
      onDragLeave: handleDragLeave,
      errorMessage: errorMessage
    }))
  });
};
exports.Uploader = Uploader;